import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var CreditCard = createReactComponent("CreditCard", ["svg", defaultAttributes, [["rect", {
  x: "1",
  y: "4",
  width: "22",
  height: "16",
  rx: "2",
  ry: "2",
  key: "16xw5y"
}], ["line", {
  x1: "1",
  y1: "10",
  x2: "23",
  y2: "10",
  key: "rh2z0g"
}]]]);
export default CreditCard;